module.exports = __webpack_public_path__ + "media/dorm_1200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/dorm_1200.jpg
// module id = 22
// module chunks = 0